export default "/images/checked.png?bd3871451ba8d47412d66aec4ad48ec3";